"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadUnitRef = exports.LoadUnit = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var LoadUnit = /** @class */ (function (_super) {
    __extends(LoadUnit, _super);
    function LoadUnit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        return _this;
    }
    LoadUnit = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/LoadUnit')
    ], LoadUnit);
    return LoadUnit;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    dimension: (0, mobx_keystone_1.prop)(),
    name: (0, mobx_keystone_1.prop)(),
})));
exports.LoadUnit = LoadUnit;
exports.loadUnitRef = (0, mobx_keystone_1.rootRef)('doc-mate/LoadUnitRef', {
    getId: function (target) {
        if (target instanceof LoadUnit) {
            return "".concat(target.id);
        }
    },
});
